import React from 'react';
import { Container, Card } from 'react-bootstrap';

const LegalNotice = () => {
  return (
    <Container className="py-5 legal-notice">
      <h1 className="text-center mb-4 fw-bold">Mentions légales</h1>
      
      {/* Société */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">Société</h2>
          <p>
            <strong>GUIRETTE SAS</strong><br />
            RCS Marseille 945 338 143<br />
            Numéro individuel d'identification TVA : FR27 945 338 143
          </p>
        </Card.Body>
      </Card>

      {/* Adresse */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">Adresse</h2>
          <p>
            <strong>GUIRETTE SAS</strong><br />
            34 Boulevard NEUF<br />
            13013 Marseille, France
          </p>
        </Card.Body>
      </Card>

      {/* Contact */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">Contact</h2>
          <p>
            Directeur de la publication : Pyrrus KOUDJOU<br />
            Responsable éditorial : Erik WAGNA
          </p>
          <p>
            Téléphone : <a href="tel:+33685449935">+33 6 85 44 99 35</a><br />
            Email : <a href="mailto:hello@guirette.net">hello@guirette.net</a>
          </p>
        </Card.Body>
      </Card>

      {/* Hébergement */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">Hébergement</h2>
          <p>
            Le site guirette.net est hébergé par :<br />
            <strong>LWS France</strong><br />
            10 rue Penthièvre 75008 Paris (FRANCE)<br />
            +33 177 62 30 03
          </p>
        </Card.Body>
      </Card>


      {/* Propriété intellectuelle */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <h2 className="h4 mb-3 fw-bold">Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus (textes, images, vidéos, logos) présents sur le site guirette.net 
            sont la propriété exclusive de GUIRETTE SAS ou de ses partenaires et sont protégés par les 
            lois relatives à la propriété intellectuelle.
          </p>
        </Card.Body>
      </Card>

      {/* Footer */}
      <Card className="border-0 bg-light">
        <Card.Body className="text-center">
          <p className="mb-0">
            <strong>GUIRETTE SAS</strong> - Solution SaTeCO+ pour une agriculture de précision
          </p>
          <p className="text-muted small mt-2">
            Dernière mise à jour : 04 Novembre 2025
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LegalNotice;